module.exports = __webpack_public_path__ + "static/media/google_preferred_source_badge_light.172e670e.png";